import styled from 'styled-components';

import BlockRenderer from 'components/sanity-block-renderer';

const margin = '0 0 1rem 0';
const padding = '0';
const fontStyle = 'normal';
const fontSize = '0.75rem';

const Disclaimer = styled(BlockRenderer)`
  margin: ${margin};
  padding: ${padding};
  color: ${Styles.color.grey.one};
  font-style: ${fontStyle};
  font-size: ${fontSize};
  font-family: ${Styles.fontFamily.body};
  a {
    color: ${Styles.color.grey.one};
  }
`;

export const DisclaimerPlain = styled.p`
  margin: ${margin};
  margin-top: 1rem;
  padding: ${padding};
  color: ${Styles.color.grey.one};
  font-style: ${fontStyle};
  font-size: ${fontSize};
  font-family: ${Styles.fontFamily.body};
  a {
    color: ${Styles.color.grey.one};
  }
  text-align: center;
`;

export default Disclaimer;
